<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />

        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-cubes mr-2" />Batch Pengiriman Emas
            </h5>
            <hr />
            <b-row class="mb-2">
                <b-col md="3">
                    <b-form-group label="Nama Cabang" class="mb-0">
                        <b-form-input
                            v-model="filter.branch"
                            maxlength="50"
                            @keydown.enter="getItems"
                            placeholder="Cari cabang..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data batch.
                </template>
                <template v-slot:cell(action)="row">
                    <router-link
                        :to="
                            '/emas/pengiriman/' +
                            $route.params.deliveryId +
                            '/' +
                            row.item.id
                        "
                    >
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Lihat Box"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,

            filter: {
                branch: ""
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "branch", label: "Cabang", sortable: false },
                { key: "total_boxes", label: "Total Box", sortable: false },
                {
                    key: "total_boxes_processed",
                    label: "Box Sudah Diproses",
                    sortable: false
                },
                { key: "action", label: "Aksi", sortable: false }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
            this.initStatus = 1;
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (this.filter.branch) {
                param += `&branch=${this.filter.branch}`;
            }

            const deliveryId = this.$route.params.deliveryId;

            return this.$axios
                .get(
                    `gold-deliveries/deliveries/${deliveryId}/batches${param}`
                )
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        }
    },

    created() {
        this.init();
    }
};
</script>
